import {getElement, getElements} from "./utils/utils";

const initFilter = () => {
    const countries = getElements('.c-card--bordered[data-filter-value]')
    const filterFieldLabel = getElement('.js-filters-label')

    const filterValues = new Set();

    countries.forEach(element => {
        const filterValue = element.getAttribute('data-filter-value');
        if (filterValue) {
            filterValues.add(filterValue);
        }
    });


    const filterOptionsContainer = getElement('.js-filters-options');

    if (filterOptionsContainer) {

        filterValues.forEach(value => {
            const option = document.createElement('span');
            option.textContent = value;
            option.setAttribute('data-value', value);

            option.addEventListener('click', () => {
                filterFieldLabel.innerText = value
            });

            // Append the option to the container
            filterOptionsContainer.appendChild(option);
        });
    } else {
        console.error('Filter options container not found.');
    }

    const filterField = getElement('.js-filters')
    if (filterField) {
        filterField.addEventListener('click', () => {
            filterField.classList.toggle('is-open')
        })
    }


    // Get all filter elements (e.g., <span> elements with data-value attributes)
    const filterElements = document.querySelectorAll('[data-value]');

    // Get the parent container of items to be filtered
    const parentElement = document.querySelector('.js-distributors');

    // Ensure the parent element exists
    if (!parentElement) {
        console.error('Parent element not found.');
        return;
    }

    // Add click event listener to each filter element
    filterElements.forEach(filterElement => {
        filterElement.addEventListener('click', () => {
            const filterValue = filterElement.getAttribute('data-value');
            const items = parentElement.children;

            if (filterValue === "*") {
                Array.from(items).forEach(item => {
                    item.classList.remove('hidden');
                });
            } else {

                // Filter the items
                Array.from(items).forEach(item => {
                    if (item.classList.contains(filterValue)) {
                        // Show items matching the class name
                        item.classList.remove('hidden');
                    } else {
                        // Hide items that don't match
                        item.classList.add('hidden');
                    }
                });
            }
        });

    });
}

export {initFilter}
